import React from 'react';
import ConsultantTicketCreateContainer from '../ConsultantTicketCreate/ConsultantTicketCreateContainer';
import CreateConsultantBroadcastForm from '../../components/forms/ConsultantTicket/CreateConsultantBroadcastForm';

// The broadcast create reuses the shared ticket create container.
// Passing FormComponent overrides the default ticket form with the broadcast form.
const ConsultantBroadcastCreateContainer = (props) => (
  <ConsultantTicketCreateContainer {...props} FormComponent={CreateConsultantBroadcastForm} />
);

export default ConsultantBroadcastCreateContainer;
